import * as echarts from "echarts/core";
import { feature } from "topojson-client";
import topologyData from "us-atlas/states-10m.json" with { type: "json" };

// The us-atlas JSON conforms to the TopoJSON Topology contract but ships
// without TS declarations; cast through unknown to satisfy feature()'s types.
export const registerUsaMap = () => {
  const topology = topologyData as unknown as Parameters<typeof feature>[0];
  const geoJson = feature(
    topology,
    topology.objects.states as Parameters<typeof feature>[1]
  );
  echarts.registerMap(
    "USA",
    geoJson as unknown as Parameters<typeof echarts.registerMap>[1]
  );
};
